import { render, staticRenderFns } from "./RowIndex.vue?vue&type=template&id=152b492a&"
import script from "./RowIndex.vue?vue&type=script&lang=js&"
export * from "./RowIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports